import ScenarioActionType from '@/store/modules/scenario/scenario.type'
import { StepConfigService } from '@/services/bot.service'

const types = ScenarioActionType

const StepConfigStoreMixin = {
    [types.CREATE_STEP_CONFIG] ({
        commit,
        state
    }, config) {
        let step = state.mapCodeToStep[config.step_code]
        let scenario = state.mapCodeToScenario[step.scenario_code]
        commit(types.ADD_SAVING_COUNT, 1)
        return StepConfigService.create(
            scenario.app_code,
            scenario.code,
            step.code,
            config
        ).then(result => {
            let newConfig = result.data
            step.config.push(newConfig)
            commit(types.MAP_INTENT_TO_STEP)
            commit(types.SHOULD_UPDATE_GRAPH)
            return newConfig
        }).finally(() => {
            commit(types.ADD_SAVING_COUNT, -1)
        })
    },
    [types.UPDATE_STEP_CONFIG] ({
        commit,
        state
    }, config) {
        let step = state.mapCodeToStep[config.step_code]
        let scenario = state.mapCodeToScenario[step.scenario_code]
        commit(types.ADD_SAVING_COUNT, 1)
        return StepConfigService.update(
            scenario.app_code,
            scenario.code,
            step.code,
            config.code,
            config
        ).then(result => {
            let newConfig = result.data
            let oldConfig = step.config.find(stepConfig => stepConfig.code === config.code)
            Object.assign(oldConfig, newConfig)
            commit(types.MAP_INTENT_TO_STEP)
            commit(types.SHOULD_UPDATE_GRAPH)
            return oldConfig
        }).finally(() => {
            commit(types.ADD_SAVING_COUNT, -1)
        })
    },
    [types.DELETE_STEP_CONFIG] ({
        commit,
        state
    }, config) {
        let step = state.mapCodeToStep[config.step_code]
        let scenario = state.mapCodeToScenario[step.scenario_code]
        commit(types.ADD_SAVING_COUNT, 1)
        return StepConfigService.delete(
            scenario.app_code,
            scenario.code,
            step.code,
            config.code
        ).then(() => {
            for (let i = 0; i < step.config.length; i++) {
                if (step.config[i].code === config.code) {
                    step.config.splice(i, 1)
                    break
                }
            }
            commit(types.MAP_INTENT_TO_STEP)
            commit(types.SHOULD_UPDATE_GRAPH)
            return config
        }).finally(() => {
            commit(types.ADD_SAVING_COUNT, -1)
        })
    }
}

export default StepConfigStoreMixin
